import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiClientConstant } from '@cureskin/api-client/src/constant/api-client.constant';
import { AllocatedRegimen } from 'client/app/app-constant-types';
import { ConnectionService } from '@services/connection-service';
import { UserService } from '@services/user';
import { RegimenService } from '@services/regimen-service/regimen.service';
import { ProcessedRegimen } from 'client/app/user/user-view/user-regimen/regimen.types';
import { processRegimen } from 'client/app/user/user-view/user-regimen/regimen.utils';

@Component({
  selector: 'app-report-buy-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './report-buy-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportBuyFooterComponent {
  private readonly regimenService = inject(RegimenService);
  private readonly conn = inject(ConnectionService);
  private readonly userService = inject(UserService);

  readonly regimen = input.required<AllocatedRegimen>();
  readonly concern = input<string>('');

  readonly processed = computed((): ProcessedRegimen => processRegimen(this.regimen()));

  readonly isEnglish = computed((): boolean =>
    this.userService.getUserLanguagePreference() === ApiClientConstant.LanguageString.EN);

  readonly showFooter = computed((): boolean => {
    const regimen = this.processed();
    return Boolean(regimen?.totalSP) && !regimen.active && !regimen.orderPlaced;
  });

  async buyRegimen(): Promise<void> {
    await this.regimenService.buyRegimen(this.processed() as AllocatedRegimen, this.conn.getActingUser());
  }
}
